<template>
    <div class="controle-gerencial">
        <nav-menu></nav-menu>

        <div class="w3-main w3-animate-left" style="margin-top:43px;">
          <header class="w3-container " style="padding-top:22px">
            <h5 class="w3-left  w3-col s12 m8 w3-margin-left">
              <b><i class="fa fa-chart-bar"></i> Controle gerencial</b>
            </h5>

            <button
              class="w3-button w3-theme w3-right w3-col s12 m3 w3-margin-right"
              v-on:click="mostrarModalEmpresas()">
                <b>-/+ empresas</b>
            </button>
          </header>
          <br>

          <div class="w3-container w3-animate-left" id="controle-gerencial" v-cloak>
            <div class="w3-white">
              <div class="w3-container w3-mobile" id="formulario_filtro"  v-cloak>

                <p v-show="empresas_selecionadas.length == 0">Não há empresa(s) selecionada(s).</p>

                <div 
                  style="max-height: 200px; overflow: auto" 
                  v-show="empresas_selecionadas.length > 0">

                  <table class="w3-table w3-border w3-bordered w3-striped w3-white">
                    <thead>
                      <tr>
                        <th>Empresa</th>
                        <th class="w3-hide-small">CNPJ</th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr 
                        v-for="(empresa, empresa_index) in empresas_selecionadas" 
                        :key="empresa_index">

                        <td>{{empresa.empresa_id}} - {{empresa.nome_fantasia}}</td>
                        <td class="w3-hide-small">{{empresa.cnpj}}</td>
                        <td style="text-align: right">
                          <button
                            class="w3-button w3-theme w3-tiny"
                            style="text-align: right"
                            v-on:click="adicionarRemoverEmpresa(empresa.empresa_id, true)">
                              <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="filtro-controlegerencial">
                  <div class="w3-col s12 m6 l4  w3-center w3-mobile margin-aplicada tres">
                    <h5 class="w3-col s12 m6 l5">Tipo de relatório</h5>
                    <input
                      class="w3-radio w3-col s1"
                      style="margin-top: 4px;"
                      v-model="tipo_processamento"
                      type="radio"
                      id="h"
                      value="H">

                    <label
                      for="h"
                      class="w3-col s5 m5 l3"
                      style="line-height: 43px; text-align: left">
                      Somente hoje
                    </label>

                    <input
                      class="w3-radio w3-col s1"
                      style="margin-top: 4px;"
                      v-model="tipo_processamento"
                      type="radio"
                      id="m"
                      value="M">

                    <label
                      for="m"
                      class="w3-col s5 m5 l2"
                      style="line-height: 43px; text-align: left">
                      Mês\Ano
                    </label>
                  </div>

                  <div
                    class="w3-col s12 m6 l4  w3-center w3-mobile  margin-aplicada tres"
                    v-show="tipo_processamento=='H'">

                    <h5 class="w3-col s12 m6 l4"> Tipo de visão </h5>
                    <input
                      class="w3-radio w3-col s1"
                      style="margin-top: 4px;"
                      v-model="tipo_visao"
                      type="radio"
                      id="f-h"
                      value="F">

                    <label
                      for="f-h"
                      class="w3-col s5 m5 l3"
                      style="line-height: 44px; text-align: left">
                      Financeira
                    </label>

                    <input
                      class="w3-radio w3-col s1"
                      style="margin-top: 4px;"
                      v-model="tipo_visao"
                      type="radio"
                      id="c-h"
                      value="C">

                    <label
                      for="c-h"
                      class="w3-col s5 m5 l3"
                      style="line-height: 44px; text-align: left">
                      Comercial
                    </label>
                  </div>

                  <div
                    class="w3-col s12 m6 l4 w3-center w3-mobile margin-aplicada tres"
                    v-show="tipo_processamento=='M'">

                    <h5 class="w3-col s12 m6 l4"> Tipo de visão </h5>

                    <input
                      class="w3-radio w3-col s1"
                      style="margin-top: 4px;"
                      v-model="tipo_visao"
                      type="radio"
                      id="f-m"
                      value="F">

                    <label
                      for="f-m"
                      class="w3-col s5 m5 l3"
                      style="line-height: 43px; text-align: left"> Financeira </label>

                    <input
                      class="w3-radio w3-col s1"
                      style="margin-top: 4px;"
                      v-model="tipo_visao"
                      type="radio"
                      id="c-m"
                      value="C">

                    <label
                      for="c-m"
                      class="w3-col s5 m5 l3"
                      style="line-height: 43px; text-align: left"> Comercial </label>
                  </div>
                  
                  <div 
                    class="w3-col s12 m6 l4 w3-center w3-mobile tres opcoes-mes"
                    v-show="tipo_processamento == 'M'">

                    <h5 class="w3-col s12 m6 l3"> Mês\Ano </h5>

                    <div 
                      class="w3-row-padding w3-col s12 m6 l9"
                      style="padding-right: 0; padding-left: 0">

                      <div
                        class="w3-half w3-col s6"
                        style="margin-top: 4px; padding-left: 0">

                        <select
                          class="w3-input w3-border"
                          name="mes_base"
                          id="mes_base"
                          v-model="mes_base">

                          <option value="1">Janeiro</option>
                          <option value="2">Fevereiro</option>
                          <option value="3">Março</option>
                          <option value="4">Abril</option>
                          <option value="5">Maio</option>
                          <option value="6">Junho</option>
                          <option value="7">Julho</option>
                          <option value="8">Agosto</option>
                          <option value="9">Setembro</option>
                          <option value="10">Outubro</option>
                          <option value="11">Novembro</option>
                          <option value="12">Dezembro</option>
                        </select>
                      </div>
                      
                      <div
                        class="w3-half w3-col s6"
                        style="margin-top: 4px; padding-right: 0">
                        
                        <select
                          class="w3-input w3-border"
                          name="ano_base"
                          id="ano_base"
                          v-model="ano_base">

                          <option value="2000">2000</option>
                          <option value="2001">2001</option>
                          <option value="2002">2002</option>
                          <option value="2003">2003</option>
                          <option value="2004">2004</option>
                          <option value="2005">2005</option>
                          <option value="2006">2006</option>
                          <option value="2007">2007</option>
                          <option value="2008">2008</option>
                          <option value="2009">2009</option>
                          <option value="2010">2010</option>
                          <option value="2011">2011</option>
                          <option value="2012">2012</option>
                          <option value="2013">2013</option>
                          <option value="2014">2014</option>
                          <option value="2015">2015</option>
                          <option value="2016">2016</option>
                          <option value="2017">2017</option>
                          <option value="2018">2018</option>
                          <option value="2019">2019</option>
                          <option value="2020">2020</option>
                          <option value="2021">2021</option>
                          <option value="2022">2022</option>
                          <option value="2023">2023</option>
                          <option value="2024">2024</option>
                          <option value="2025">2025</option>
                          <option value="2026">2026</option>
                          <option value="2027">2027</option>
                          <option value="2028">2028</option>
                          <option value="2029">2029</option>
                          <option value="2030">2030</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  
                  <div
                    class="w3-col s12 m6 l6  w3-center w3-mobile margin-aplicada opcoes-exibicao"
                    v-show="tipo_processamento == 'M'">

                    <h5 class="w3-col s12 m4 l4"> Opções de exibição </h5>
                    
                    <input 
                      class="w3-check w3-radio w3-col s1 m1" 
                      style="margin-top: 4px;" 
                      v-model="mostrar_mes_anterior" 
                      type="checkbox"
                      name="mma" 
                      id="mma" 
                      value="MMA">
                      
                    <label
                      class="w3-col s11 m3 l3" 
                      style="line-height: 43px; text-align: left"
                      for="mma">
                        <span>Mostrar mês anterior</span>
                    </label>

                    <input 
                      class="w3-check w3-radio w3-col s1 m1"
                      style="margin-top: 4px;"
                      v-model="mostrar_ano_anterior"
                      type="checkbox" 
                      name="maa" 
                      id="maa" 
                      value="MAA">
                      
                    <label 
                      class="w3-col s11 m3 l3"
                      style="line-height: 43px; text-align: left"
                      for="maa">
                      <span>Mostrar ano anterior</span>
                    </label>
                  </div>
                  
                  <div 
                    class="w3-center texto-cinza w3-col s12 m12 l2 w3-right"
                    style="text-align:right"
                    v-cloak>

                    <button 
                      class="w3-button w3-theme w3-col s12" 
                      id="btProcessar" 
                      disable="processando"                      
                      v-on:click="buscarDadosControleGerencial()">
                        <b>Processar</b>
                    </button>
                  </div>

                </div>
              </div> 
            </div>

            <div
              class="w3-container w3-col s12"
              id="labelProcessando" 
              v-if="processando">

              <p class="w3-theme w3-card-2 w3-panel w3-padding">
                <i class="fa fa-sync-alt w3-spin "></i>
                  Processando...
              </p>
            </div>

            <div
              style="padding:0px; margin:0px"
              class="w3-col s12 m12 l4"
              ref="search"
              id="cardFuncionamento"
              v-show="processado_hoje">

              <div class="w3-container">
                <div class="w3-white" style="width:100%;">
                  <header class="titulo texto-vermelho">
                    <h4>Funcionamento - Hoje</h4>
                  </header>

                  <div class="w3-row w3-margin-top w3-margin-bottom">
                    <div :class="getClasseGraficoHoras(perc_horas_faltando)">
                      <span>{{horas_transcorridas}}</span>
                      <div class="slice">
                          <div class="bar"></div>
                          <div class="fill"></div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            
            <div
              style="padding:0px; margin:0px"
              class="w3-col s12 m12 l4"
              id="cardMetas"
              v-if="processado_hoje">

              <div class="w3-container">
                <div class="w3-white" style="width:100%;">

                  <header class="titulo texto-vermelho">
                    <h4>%Meta - Hoje</h4>
                  </header>

                  <div class="w3-row w3-margin-top w3-margin-bottom">
                    <span v-if="meta_hoje == 0">
                      <span>Não há metas definidas para o hoje nas empresas selecionadas.</span>
                    </span>

                    <div :class="getClasseGraficoHoras(perc_meta_hoje)" v-else>
                      <span>{{getPercentualMeta(perc_meta_hoje)}}%</span>
                      <div class="slice">
                        <div class="bar"></div>
                        <div class="fill"></div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div
              style="padding:0px; margin:0px"
              class="w3-col s12 m12 l4"
              id="cardMetas"
              v-if="processado_hoje">

              <div class="w3-container">
                <div class="w3-white" style="width:100%;">
                  <header class="titulo texto-vermelho">
                    <h4>%Meta - {{mes_selecionado}} de {{ano_selecionado}}</h4>
                  </header>

                  <div class="w3-row w3-margin-top w3-margin-bottom">
                    <span v-if="meta_periodo == 0">
                      <span>Não há metas definidas para o período e empresas selecionadas.</span>
                    </span>

                    <div :class="getClasseGraficoHoras(perc_meta_periodo)" v-else>
                      <span>{{getPercentualMeta(perc_meta_periodo)}}%</span>
                      <div class="slice">
                        <div class="bar"></div>
                        <div class="fill"></div>
                      </div>
                    </div>  

                  </div>

                </div>
              </div>
            </div>

            <div class="w3-col s12 m12 l12" id="cardMetas" v-if="processado_mes_ano">
              <div class="w3-container">
                <div class="w3-white" style="width:100%;">
                  <header class=" titulo texto-vermelho">
                    <h4>%Meta - {{mes_selecionado}} de {{ano_selecionado}}</h4>
                  </header>

                  <div class="w3-row w3-margin-top w3-margin-bottom">
                    <span v-if="meta_periodo == 0">
                      <span>Não há metas definidas para o período e empresas selecionadas.</span>
                    </span>

                    <div :class="getClasseGraficoHoras(perc_meta_periodo)" v-else>
                      <span>{{getPercentualMeta(perc_meta_periodo)}}%</span>
                      <div class="slice">
                        <div class="bar"></div>
                        <div class="fill"></div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div
              style="padding:0px; margin:0px"
              class="w3-container"
              v-if="processado_hoje">

              <div class="w3-white" style="width:100%;">
                <header class=" titulo texto-vermelho">
                  <h4>Vendas e previsões de vendas - Hoje</h4>
                </header>

                <div class="w3-row w3-margin-top w3-margin-bottom">
                  <div class="w3-hide-large w3-hide-medium">
                    <div class="w3-col s12">
                      <strong>Vendas líquidas</strong>
                      <label class="w3-right">{{formatarValor(vendas_hoje)}}</label>
                    </div>

                    <div class="w3-col s12">
                      <strong>Meta diária</strong>
                      <label class="w3-right">{{formatarValor(meta_hoje)}}</label>
                    </div>

                    <div class="w3-col s12">
                      <strong>Previsão de vendas</strong>
                      <label class="w3-right">{{formatarValor(vendas_previsao_dia)}}</label>
                    </div>

                    <div class="w3-col s12">
                      <strong>Ticket médio</strong>
                      <label class="w3-right">{{formatarValor(ticket_hoje)}}</label>
                    </div>

                    <div class="w3-col s12">
                      <strong>% Lucro presente</strong>
                      <label class="w3-right">{{formatarValor(perc_lucro_hoje)}} %</label>
                    </div>

                    <div class="w3-col s12">
                      <strong>Lucro líquido</strong>
                      <label class="w3-right">{{formatarValor(valor_lucro_hoje)}}</label>
                    </div>
                  </div>

                  <div class="w3-responsive w3-hide-small">
                    <table class="w3-table-all">
                      <thead>
                        <tr>
                          <th class="alinhamento-numero">Vendas líquidas</th>
                          <th class="alinhamento-numero">Meta diária</th>
                          <th class="alinhamento-numero">Previsão de vendas</th>
                          <th class="alinhamento-numero">Ticket médio</th>
                          <th class="alinhamento-numero">% Lucro presente</th>
                          <th class="alinhamento-numero">Lucro líquido</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td class="alinhamento-numero">{{formatarValor(vendas_hoje)}}</td>
                          <td class="alinhamento-numero">{{formatarValor(meta_hoje)}}</td>
                          <td class="alinhamento-numero">{{formatarValor(vendas_previsao_dia)}}</td>
                          <td class="alinhamento-numero">{{formatarValor(ticket_hoje)}}</td>
                          <td class="alinhamento-numero">{{formatarValor(perc_lucro_hoje)}}%</td>
                          <td class="alinhamento-numero">{{formatarValor(valor_lucro_hoje)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>

            <div
              style="padding: 0px; margin: 0px"
              class="w3-container"
              id="cardMeta"
              v-if="processado_mes_ano || processado_hoje">

              <div class="w3-white" style="width:100%;">
                <header class=" titulo texto-vermelho">
                  <h4>
                    <span>Vendas - </span>
                    <span v-if="processado_mes_ano">{{mes_selecionado}} de {{ano_selecionado}}</span>
                    <span v-else>Hoje</span>
                  </h4>
                </header>

                <br>

                <div
                  style="padding:0px; margin:0px"
                  class="w3-row"
                  v-for="(venda, venda_index) in dados_vendas_empresas"
                  :key="venda_index"
                  v-cloak>

                  <div class="card-vendas-empresa">
                    <div class="w3-container" style="padding:0px 5px 5px 5px">
                      <div class="w3-col s12">
                        <label
                          class="w3-text-theme label-clicavel"
                          v-on:click="mostrarDetalhesVendasEmpresas(venda.empresa_id)">
                            <strong>{{venda.nome_fantasia}}</strong>
                        </label>
                      </div>

                      <div
                        class="w3-col s12 label-clicavel"
                        v-on:click="mostrarDetalhesVendasEmpresas(venda.empresa_id)">

                        <div class="w3-hide-large w3-hide-medium">
                          <div class="w3-col s12">
                            <strong>Quantidade vendas</strong>
                            <label class="w3-right">{{formatarValor(venda.quantidade, 0)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Vendas</strong>
                            <label class="w3-right">{{formatarValor(venda.vendas)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Custos</strong>
                            <label class="w3-right">{{formatarValor(venda.custos)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Devoluções</strong>
                            <label class="w3-right">{{formatarValor(venda.devolucoes)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Vendas líquidas</strong>
                            <label class="w3-right">{{formatarValor(venda.vendas_liquidas)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>% Lucro presente</strong>
                            <label class="w3-right">{{formatarValor(venda.perc_lucro_presente)}} %</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Lucro presente</strong>
                            <label class="w3-right">{{formatarValor(venda.valor_lucro_presente)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>% Lucro líquido</strong>
                            <label class="w3-right">{{formatarValor(venda.perc_lucro)}} %</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Lucro líquido</strong>
                            <label class="w3-right">{{formatarValor(venda.valor_lucro)}}</label>
                          </div>
                        </div>

                        <div class="w3-responsive w3-hide-small">
                          <table class="w3-table-all">
                            <thead>
                              <tr>
                                <th class="alinhamento-numero">Quantidade vendas</th>
                                <th class="alinhamento-numero">Vendas</th>
                                <th class="alinhamento-numero">Devoluções</th>
                                <th class="alinhamento-numero">Vendas líquidas</th>
                                <th class="alinhamento-numero">Custos</th>
                                <th class="alinhamento-numero">% Lucro presente</th>
                                <th class="alinhamento-numero">Lucro presente</th>
                                <th class="alinhamento-numero">% Lucro líquido</th>
                                <th class="alinhamento-numero">Lucro líquido</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td class="alinhamento-numero">{{formatarValor(venda.quantidade, 0)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(venda.vendas)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(venda.devolucoes)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(venda.vendas_liquidas)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(venda.custos)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(venda.perc_lucro_presente)}} %</td>
                                <td class="alinhamento-numero">{{formatarValor(venda.valor_lucro_presente)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(venda.perc_lucro)}} %</td>
                                <td class="alinhamento-numero">{{formatarValor(venda.valor_lucro)}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="w3-col s12" v-show="venda.visualizar">
                        <hr>
                        <div class="w3-animate-left">
                          <div class="w3-responsive">
                            <table class="w3-table-all">
                              <thead>
                                <tr>
                                  <th>Data de recebimento</th>
                                  <th>Dia da semana</th>
                                  <th class="alinhamento-numero">Quantidade vendas</th>
                                  <th class="alinhamento-numero">Vendas</th>
                                  <th class="alinhamento-numero">Devoluções</th>
                                  <th class="alinhamento-numero">Vendas liquidas</th>
                                  <th class="alinhamento-numero">Custos</th>
                                  <th class="alinhamento-numero">% Lucro presente</th>
                                  <th class="alinhamento-numero">Lucro presente</th>
                                  <th class="alinhamento-numero">% Lucro líquido</th>
                                  <th class="alinhamento-numero">Lucro líquido</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(detalhe, detalhe_index) in venda.detalhes" :key="detalhe_index">
                                  <td>{{detalhe.data_recebimento}}</td>
                                  <td>{{detalhe.dia_semana}}</td>
                                  <td class="alinhamento-numero">{{detalhe.quantidade}}</td>
                                  <td class="alinhamento-numero">{{detalhe.vendas}}</td>
                                  <td class="alinhamento-numero">{{detalhe.devolucoes}}</td>
                                  <td class="alinhamento-numero">{{detalhe.vendas_liquidas}}</td>
                                  <td class="alinhamento-numero">{{detalhe.custos}}</td>
                                  <td class="alinhamento-numero">{{detalhe.perc_lucro_presente}} %</td>
                                  <td class="alinhamento-numero">{{detalhe.valor_lucro_presente}}</td>
                                  <td class="alinhamento-numero">{{detalhe.perc_lucro}} %</td>
                                  <td class="alinhamento-numero">{{detalhe.valor_lucro}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div
                  style="padding:0px; margin:0px"
                  class="w3-row"
                  v-if="totais_todas_empresas.quantidade">

                  <div class="card-vendas-totais">
                    <div class="w3-container" style="padding:0px 5px 5px 5px">
                      <div class="w3-col s12">
                        <label class="w3-text-preto"><strong>TOTAIS</strong></label>
                      </div>

                      <div class="w3-col s12">
                        <div class="w3-hide-large w3-hide-medium">
                          <div class="w3-col s12">
                            <strong>Quantidade vendas</strong>
                            <label class="w3-right">{{formatarValor(totais_todas_empresas.quantidade, 0)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Vendas</strong>
                            <label class="w3-right">{{formatarValor(totais_todas_empresas.vendas)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Custos</strong>
                            <label class="w3-right">{{formatarValor(totais_todas_empresas.custos)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Devoluções</strong>
                            <label class="w3-right">{{formatarValor(totais_todas_empresas.devolucoes)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Vendas líquidas</strong>
                            <label class="w3-right">{{formatarValor(totais_todas_empresas.vendas_liquidas)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>% Lucro presente</strong>
                            <label class="w3-right">{{formatarValor(totais_todas_empresas.perc_lucro_presente)}} %</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Lucro presente</strong>
                            <label class="w3-right">{{formatarValor(totais_todas_empresas.valor_lucro_presente)}}</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>% Lucro líquido</strong>
                            <label class="w3-right">{{formatarValor(totais_todas_empresas.perc_lucro)}} %</label>
                          </div>

                          <div class="w3-col s12">
                            <strong>Lucro líquido</strong>
                            <label class="w3-right">{{formatarValor(totais_todas_empresas.valor_lucro)}}</label>
                          </div>
                        </div>

                        <div class="w3-responsive w3-hide-small">
                          <table class="w3-table-all">
                            <thead>
                              <tr>
                                <th class="alinhamento-numero">Quantidade vendas</th>
                                <th class="alinhamento-numero">Vendas</th>
                                <th class="alinhamento-numero">Devoluções</th>
                                <th class="alinhamento-numero">Vendas líquidas</th>
                                <th class="alinhamento-numero">Custos</th>
                                <th class="alinhamento-numero">% lucro presente</th>
                                <th class="alinhamento-numero">Lucro presente</th>
                                <th class="alinhamento-numero">% lucro líquido</th>
                                <th class="alinhamento-numero">Lucro líquido</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="alinhamento-numero">{{formatarValor(totais_todas_empresas.quantidade, 0)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(totais_todas_empresas.vendas)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(totais_todas_empresas.devolucoes)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(totais_todas_empresas.vendas_liquidas)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(totais_todas_empresas.custos)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(totais_todas_empresas.perc_lucro_presente)}} %</td>
                                <td class="alinhamento-numero">{{formatarValor(totais_todas_empresas.valor_lucro_presente)}}</td>
                                <td class="alinhamento-numero">{{formatarValor(totais_todas_empresas.perc_lucro)}} %</td>
                                <td class="alinhamento-numero">{{formatarValor(totais_todas_empresas.valor_lucro)}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <br>
              </div>
            </div>

            <div
              style="padding:0px; margin:0px"
              class="w3-container"
              id="cardMeta"
              v-if="processado_mes_ano || processado_hoje">

              <div class="w3-white" style="width:100%;">
                <header class=" titulo texto-vermelho">
                  <h4>
                    <span>Formas de pagamento - </span>
                    <span v-if="processado_mes_ano">{{mes_selecionado}} de {{ano_selecionado}}</span>
                    <span v-else>Hoje</span>
                  </h4>
                </header>

                <button
                  class="btn-mix button-link"
                  style="margin:10px;"
                  @click="mostrar_formas_pagamento = true"
                  v-show="!mostrar_formas_pagamento">
                    <span>Visualizar totais de formas de pagamento</span>
                </button>

                <button
                  class="btn-mix button-link"
                  style="margin:10px;"
                  @click="mostrar_formas_pagamento = false"
                  v-show="mostrar_formas_pagamento">
                    <span>Ocultar totais de formas de pagamento</span>
                </button>

                <br v-show="mostrar_formas_pagamento">

                <table class="w3-table-all" v-show="mostrar_formas_pagamento">
                  <thead>
                    <tr>
                      <th>Forma de pagamento</th>
                      <th class="alinhamento-numero">Valor</th>
                      <th class="alinhamento-numero">A.V.</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(forma, forma_index) in dados_formas_pagamento" :key="forma_index">
                      <td>{{forma.forma_pagamento}}</td>
                      <td class="alinhamento-numero">{{formatarValor(forma.valor)}}</td>
                      <td class="alinhamento-numero">{{formatarValor(forma.percentual)}}%</td>
                    </tr>
                  </tbody>
                </table>

                <br>

              </div>
            </div>

            <div
              style="padding:0px; margin:0px;"
              class="w3-container"
              id="cardVenda"
              v-show="processado_mes_ano">

              <div class="w3-white" style="width:100%;">
                <header class=" titulo texto-vermelho">
                  <h4>Painel de vendas - {{mes_selecionado}} de {{ano_selecionado}}</h4>
                </header>

                <div style="padding:0px; margin:0px" class="w3-row">
                  <div class="w3-col m4 w3-white w3-center w3-mobile">
                    <h5>Mês da pesquisa</h5>
                    <p>R$ {{vendas_mes_base}} </p>
                    <br>
                  </div>

                  <div class="w3-col m4 w3-white w3-center w3-mobile">
                    <h5>Mês anterior</h5>
                    <p>R$ {{vendas_mes_anterior}}</p>
                    <br>
                  </div>

                  <div class="w3-col m4 w3-white w3-center w3-mobile">
                    <h5>Ano anterior</h5>
                    <p>R$ {{vendas_ano_anterior}}</p>
                    <br>
                  </div>
                </div>

                <div class="w3-responsive">
                  <table class="w3-table-all" style="width:950px">
                    <tbody>
                      <tr>
                        <td class="w3-container" id="vendasChart">
                          <canvas id="painel_vendas"></canvas>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <br>
            </div>

            <div
              class="w3-container"
              style="padding:0px; margin:0px;"
              id="cardTicket"
              v-show="processado_mes_ano">

              <div class="w3-white" style="width:100%;">
                <header class=" titulo texto-vermelho">
                  <h4>Ticket médio - {{mes_selecionado}} de {{ano_selecionado}}</h4>
                </header>

                <div style="padding:0px; margin:0px" class="w3-row w3-mobile">
                  <div class="w3-col m4 w3-white w3-center w3-mobile">
                    <h5>Mês da pesquisa</h5>
                    <p>R$ {{ticket_mes_base}}</p>
                    <br>
                  </div>

                  <div class="w3-col m4 w3-white w3-center w3-mobile">
                    <h5>Mês anterior</h5>
                    <p>R$ {{ticket_mes_anterior}}</p>
                    <br>
                  </div>

                  <div class="w3-col m4 w3-white w3-center w3-mobile">
                    <h5>Ano anterior</h5>
                    <p>R$ {{ticket_ano_anterior}}</p>
                    <br>
                  </div>
                </div>

                <div class="w3-responsive">
                  <table class="w3-table-all" style="width:950px">
                    <tbody>
                      <tr>
                        <td  class="w3-container" id="ticketChart">
                          <canvas id="painel_ticket"></canvas>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

              <br>
            </div>

            <div
              style="padding:0px; margin:0px"
              class="w3-container"
              id="cardLucro"
              v-show="processado_mes_ano">

              <div class="w3-white" style="width:100%;">
                <header class=" titulo texto-vermelho">
                  <h4>Lucro presente (%) - {{mes_selecionado}} de {{ano_selecionado}}</h4>
                </header>

                <div style="padding:0px; margin:0px" class="w3-row w3-mobile">
                  <div class="w3-col m4 w3-white w3-center w3-mobile">
                    <h5>Mês da pesquisa</h5>
                    <p>{{lucro_mes_base}}%</p>
                    <br>
                  </div>

                  <div class="w3-col m4 w3-white w3-center w3-mobile">
                    <h5>Mês anterior</h5>
                    <p>{{lucro_mes_anterior}}%</p>
                    <br>
                  </div>
                  
                  <div class="w3-col m4 w3-white w3-center w3-mobile">
                    <h5>Ano anterior</h5>
                    <p>{{lucro_ano_anterior}}%</p>
                    <br>
                  </div>
                </div>
                
                <div class="w3-responsive">
                  <table class="w3-table-all" style="width:950px">
                    <tbody>
                      <tr>
                        <td  class="w3-container" id="lucroChart">
                          <canvas id="painel_lucro"></canvas>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
              <br>
            </div>

            <div 
              id="modalInserirEmpresas"
              v-if="mostrarModalInserirEmpresas"
              @click="mostrarModalInserirEmpresas = false" 
              style="display: block" 
              class="w3-modal">

              <div class="w3-modal-content w3-animate-zoom" @click.stop>
                <header class="w3-container">
                  <span
                    @click="mostrarModalInserirEmpresas = false"
                    class="w3-button w3-display-topright">&times;</span>

                  <h2 class="texto-vermelho titulo">Empresas disponíveis</h2>
                </header>

                <div class="w3-container">

                  <div class="w3-col">
                    <br>

                    <div 
                      class="w3-responsive"
                      style="max-height: calc(100vh - 320px);min-height: 200px;overflow: auto">

                      <table class="w3-table w3-border w3-bordered w3-striped w3-white">
                        <thead>
                          <th>Código</th>
                          <th>Nome fantasia</th>
                          <th class="w3-hide-small">CNPJ</th>
                        </thead>

                        <tbody>
                          <tr 
                            v-for="(empresa, empresa_index) in empresas_autorizadas"
                            :key="empresa_index"
                            :class="getClasseEmpresaDisponivel(empresa.adicionado)"
                            v-on:click="adicionarRemoverEmpresa(empresa.empresa_id, empresa.adicionado)">

                            <td>{{empresa.empresa_id}}</td>
                            <td>{{empresa.nome_fantasia}}</td>
                            <td class="w3-hide-small">{{empresa.cnpj}}</td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>
                </div>

                <footer class="w3-container conteudo-centralizado">
                  <button
                    class="w3-btn w3-theme"
                    id="btn-confirmar-acao"
                    style="margin-top: 10px; margin-bottom:10px"
                    @click="mostrarModalInserirEmpresas = false">
                      <span>Ok</span>
                  </button>
                </footer>

              </div>
            </div>
          </div>

          <div id="carregar_rodape"></div>
        </div>
    </div>
</template>

<script>
  import toastr from 'toastr'
  import VueCharts from 'vue-chartjs'
  import store from '@/ambiente/store'
  import NavMenu from '@/components/Menu'
  import RSessao from '@/components/Rest/RSessao'
  import RControleGerencial from '@/components/Rest/RControleGerencial.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'

  export default {
    name: 'ControleGerencial',

    components: {
      NavMenu
    },

    data () {
      return {
        dados_vendas_empresas: [],
        dados_formas_pagamento: [],
        valor_venda_ano_anterior: [],
        valor_venda_mes_anterior: [],
        valor_venda: [],
        data_recebimento: [],
        data_recebimento_mes_anterior: [],
        data_recebimento_ano_anterior: [],
        valor_ticket_ano_anterior: [],
        valor_ticket_mes_anterior: [],
        ticket_medio: [],
        valor_lucro_ano_anterior: [],
        valor_lucro_mes_anterior: [],
        lucro_percentual: [],
        empresas_autorizadas: [],
        empresa_selecionada_id: '',
        tipo_visao: '',
        mes_base: '',
        ano_base: '',
        mes_selecionado: '',
        ano_selecionado: '',
        mostrar_mes_anterior: true,
        mostrar_ano_anterior: true,
        vendas_ano_anterior: '',
        vendas_mes_anterior: '',
        vendas_mes_base: '',
        vendas_hoje: '',
        vendas_previsao_dia: '',
        ticket_ano_anterior: '',
        ticket_mes_anterior: '',
        ticket_mes_base: '',
        ticket_hoje: '',
        lucro_mes_base: '',
        lucro_mes_anterior: '',
        lucro_ano_anterior: '',
        perc_lucro_hoje: '',
        valor_lucro_hoje: '',
        horas_transcorridas: '',
        horas_faltando: '',
        perc_horas_faltando: '',
        empresas_selecionadas: [],
        processando: false,
        tipo_processamento: 'H',
        processado_hoje: false,
        processado_mes_ano: false,
        meta_periodo: 0,
        perc_meta_periodo: 0,
        meta_hoje: 0,
        perc_meta_hoje: 0,
        mostrar_formas_pagamento: false,
        arrayDiasSemana: [],
        totais_todas_empresas: {},
        mostrarModalInserirEmpresas: false
      }
    },

    watch: {
      mostrarModalInserirEmpresas() {
        this.verificarModalAberto()   
      },

      tipo_visao(){
        localStorage.setItem('tipo_visao_controle_gerencial', this.tipo_visao)
      }
    },

    computed: {
      verificarModal() {
        if (this.mostrarModalInserirEmpresas) {
          return true
        }
        
        return false     
      }
    },

    methods: {
      verificarModalAberto() {
        const el = document.documentElement;

        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        }
        else {
          el.classList.remove('modal-aberto');
        }
      },

      async buscarDadosControleGerencial() {
        let data_atual = new Date();
        let mes_atual;
        let ano_atual;

        data_atual = data_atual.toLocaleString();
        mes_atual = data_atual.slice(3, 5);
        ano_atual = data_atual.slice(6, 10);

        if (this.empresas_selecionadas.length == 0) {
          toastr.error('É necessário selecionar empresa(s) para a pesquisa!');
          return;
        }

        if (!this.mes_base) {
          toastr.error('É necessário preencher o mês base para a pesquisa!');
          document.getElementById('mes_base').focus();
          return;
        }

        if (this.ano_base == '') {
          toastr.error('É necessário preencher o ano base para a pesquisa!');
          document.getElementById('ano_base').focus();
          return;
        }

        if (this.tipo_visao == '') {
          toastr.error('É necessário selecionar o tipo de visão!');
          return;
        }

        if (
          (Biblioteca.valorInt(this.mes_base) > Biblioteca.valorInt(mes_atual)) && 
          (Biblioteca.valorInt(this.ano_base) == Biblioteca.valorInt(ano_atual))
        ) {
          toastr.error('O mês selecionado é maior que o atual!');
          return;
        }

        if (Biblioteca.valorInt(this.ano_base) > Biblioteca.valorInt(ano_atual)) {
          toastr.error('O ano selecionado é maior que o ano atual!');
          return;
        }

        let empresas_ids = [];

        for (let i = 0; i < this.empresas_selecionadas.length; i++) {
          empresas_ids.push(this.empresas_selecionadas[i].empresa_id);
        }

        this.processado_hoje = false;
        this.processado_mes_ano = false;
        this.processando = true;
        
        setTimeout(
          function() {
            $('html,body').animate(
              {scrollTop: ($('#labelProcessando')).offset().top}
            );
          }, 
          300
        );
        
        this.totais_todas_empresas = {};
        
        try {
          let parametros = {
            empresas_ids: empresas_ids,
            tipo_visao: this.tipo_visao,
            tipo_relatorio: this.tipo_processamento,
            data: (this.ano_base + '/' + formatarMesPadrao(this.mes_base)),
            mostrar_ano_anterior: Biblioteca.booleanToChar(this.mostrar_ano_anterior),
            mostrar_mes_anterior: Biblioteca.booleanToChar(this.mostrar_mes_anterior)
          };

          let retorno = await RControleGerencial.buscarDadosControleGerencial(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }
          
          let gerencial = retorno.dados;

          this.ano_selecionado = this.ano_base;
          this.mes_selecionado = $('#mes_base option:selected').text();

          this.data_recebimento = gerencial.data_recebimento;
          this.data_recebimento_mes_anterior = gerencial.data_recebimento_mes_anterior;
          this.data_recebimento_ano_anterior = gerencial.data_recebimento_ano_anterior;
          this.valor_venda_ano_anterior = gerencial.valor_venda_ano_anterior;
          this.valor_venda_mes_anterior = gerencial.valor_venda_mes_anterior;
          this.valor_venda = gerencial.valor_venda;
          this.valor_ticket_ano_anterior = gerencial.valor_ticket_ano_anterior;
          this.valor_ticket_mes_anterior = gerencial.valor_ticket_mes_anterior;
          this.ticket_medio = gerencial.ticket_medio;
          this.valor_lucro_ano_anterior = gerencial.valor_lucro_ano_anterior;
          this.valor_lucro_mes_anterior = gerencial.valor_lucro_mes_anterior;
          this.lucro_percentual = gerencial.percentual_lucro;
          
          ExibirGraficoVendas(
            this.data_recebimento, 
            this.data_recebimento_mes_anterior, 
            this.data_recebimento_ano_anterior, 
            this.valor_venda_ano_anterior, 
            this.valor_venda_mes_anterior, 
            this.valor_venda
          );
          
          ExibirGraficoTicket(
            this.data_recebimento,
            this.data_recebimento_mes_anterior,
            this.data_recebimento_ano_anterior,
            this.valor_ticket_ano_anterior,
            this.valor_ticket_mes_anterior,
            this.ticket_medio
          );
          
          ExibirGraficoLucros(
            this.data_recebimento,
            this.data_recebimento_mes_anterior,
            this.data_recebimento_ano_anterior,
            this.valor_lucro_ano_anterior,
            this.valor_lucro_mes_anterior,
            this.lucro_percentual
          );

          this.horas_transcorridas = gerencial.horas_transcorrido;
          this.horas_faltando = gerencial.horas_faltando; 

          let hora_transcorrida_int = Biblioteca.valorInt(horaParaSegundo(gerencial.horas_transcorrido));
          let hora_faltando_int = Biblioteca.valorInt(horaParaSegundo(gerencial.horas_faltando));
          
          this.perc_horas_faltando = (
            100 * hora_transcorrida_int / (hora_faltando_int + hora_transcorrida_int)
          ).toFixed(0);

          this.vendas_ano_anterior = gerencial.venda_ano_anterior;
          this.vendas_mes_anterior = gerencial.venda_mes_anterior;
          this.vendas_mes_base = gerencial.venda_mes_base; 
          this.vendas_hoje = Biblioteca.valor(gerencial.venda_hoje);
          this.vendas_previsao_dia = Biblioteca.valor(gerencial.venda_previsao_dia);
          this.ticket_ano_anterior = gerencial.ticket_ano_anterior;
          this.ticket_mes_anterior = gerencial.ticket_mes_anterior;
          this.ticket_mes_base = gerencial.ticket_mes_base;
          this.ticket_hoje = Biblioteca.valor(gerencial.ticket_hoje);
          this.lucro_mes_base = gerencial.lucro_mes_base;
          this.lucro_mes_anterior = gerencial.lucro_mes_anterior;
          this.lucro_ano_anterior = gerencial.lucro_ano_anterior;
          this.perc_lucro_hoje = Biblioteca.valor(gerencial.perc_lucro_hoje);
          this.valor_lucro_hoje = Biblioteca.valor(gerencial.valor_lucro_hoje);
          this.meta_periodo = Biblioteca.valor(gerencial.meta_periodo);
          
          if (Biblioteca.valor(gerencial.meta_periodo) > 0) {
            this.perc_meta_periodo = (
              Biblioteca.valor(gerencial.venda_mes_base) / 
              Biblioteca.valor(gerencial.meta_periodo) *
              100
            ).toFixed(2);
          }
          else {
            this.perc_meta_periodo = 0;
          }

          this.meta_hoje = (
            (Biblioteca.valor(gerencial.meta_periodo)) / 
            (Biblioteca.valor(gerencial.media_dias_uteis))
          ).toFixed(2);

          this.perc_meta_hoje = (
            this.vendas_hoje / 
            (Biblioteca.valor(gerencial.meta_periodo) / 
            Biblioteca.valor(gerencial.media_dias_uteis)) * 100
          ).toFixed(2);

          this.buscarInformacoesPainelVendas();
          this.buscarDadosVendasFormasPagamento();

          this.processando = false;
          
          if (this.tipo_processamento == 'H') {
            this.processado_hoje = true;

            setTimeout(
              function() {
                $('html,body').animate({scrollTop: ($('#cardFuncionamento')).offset().top});
              }, 
              300
            );
          }
          else {
            this.processado_mes_ano = true;

            setTimeout(
              function() {
                $('html,body').animate({scrollTop: ($('#cardMetas')).offset().top});
              },
              300
            );
          }
        }
        catch (error) {
          toastr.error(error.message);
          this.processando = false;
        }
      },

      async buscarDadosVendasFormasPagamento() {
        let empresas_ids = [];
        this.dados_formas_pagamento = [];
        this.mostrar_formas_pagamento = false;

        for (let i = 0; i < this.empresas_selecionadas.length; i++) {
          empresas_ids.push(this.empresas_selecionadas[i].empresa_id);
        }

        try {
          let parametros = {
            empresas_ids: empresas_ids,
            tipo_relatorio: this.tipo_processamento,
            data: this.ano_base + '/' + this.mes_base
          }

          let retorno = await RControleGerencial.buscarDadosVendasFormasPagamento(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          let formas_pagamento = retorno.dados;

          const c_dinheiro       = 0;
          const c_cheque_vista   = 1;
          const c_cheque_prazo   = 2;
          const c_cartao_debito  = 3
          const c_cartao_credito = 4;
          const c_duplicata      = 5;
          const c_boleto         = 6;
          const c_financeira     = 7;
          const c_acumulativo    = 8;
          const c_credito        = 9;
          const c_pix            = 10;
          const c_total          = 11;

          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Dinheiro',
              valor: 0,
              percentual: 0
            }
          );

          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Cheque à vista',
              valor: 0,
              percentual: 0
            }
          );
          
          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Cheque à prazo',
              valor: 0,
              percentual: 0
            }
          );
          
          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Cartão de débito',
              valor: 0,
              percentual: 0
            }
          );
          
          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Cartão de crédito',
              valor: 0,
              percentual: 0
            }
          );
          
          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Duplicata',
              valor: 0,
              percentual: 0
            }
          );
          
          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Boleto',
              valor: 0,
              percentual: 0
            }
          );
          
          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Financeira',
              valor: 0,
              percentual: 0
            }
          );
          
          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Acumulativo',
              valor: 0,
              percentual: 0
            }
          );
          
          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Crédito',
              valor: 0,
              percentual: 0
            }
          );

          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Pix',
              valor: 0,
              percentual: 0
            }
          );

          this.dados_formas_pagamento.push(
            {
              forma_pagamento: 'Total',
              valor: 0,
              percentual: 0
            }
          );

          if (
            (!formas_pagamento.vendas_formas_pagamento) ||
            (formas_pagamento.vendas_formas_pagamento.length == 0)
          ) {
            return;
          }

          for (let i = 0; i < formas_pagamento.vendas_formas_pagamento.length; i++) {
            let obj_pagamento = formas_pagamento.vendas_formas_pagamento[i];
            this.dados_formas_pagamento[c_dinheiro].valor += Biblioteca.valor(obj_pagamento.valor_dinheiro);
            this.dados_formas_pagamento[c_cheque_vista].valor += Biblioteca.valor(obj_pagamento.valor_cheque_vista);
            this.dados_formas_pagamento[c_cheque_prazo].valor += Biblioteca.valor(obj_pagamento.valor_cheque_prazo);
            this.dados_formas_pagamento[c_cartao_debito].valor += Biblioteca.valor(obj_pagamento.valor_cartao_db);
            this.dados_formas_pagamento[c_cartao_credito].valor += Biblioteca.valor(obj_pagamento.valor_cartao_cr);
            this.dados_formas_pagamento[c_duplicata].valor += Biblioteca.valor(obj_pagamento.valor_duplicata);
            this.dados_formas_pagamento[c_boleto].valor += Biblioteca.valor(obj_pagamento.valor_boleto);
            this.dados_formas_pagamento[c_financeira].valor += Biblioteca.valor(obj_pagamento.valor_financeira);
            this.dados_formas_pagamento[c_acumulativo].valor += Biblioteca.valor(obj_pagamento.valor_acumulativo);
            this.dados_formas_pagamento[c_pix].valor += Biblioteca.valor(obj_pagamento.valor_pix);
            this.dados_formas_pagamento[c_credito].valor += Biblioteca.valor(obj_pagamento.valor_credito);
          }

          this.dados_formas_pagamento[c_total].valor += (
            this.dados_formas_pagamento[c_dinheiro].valor +
            this.dados_formas_pagamento[c_cheque_vista].valor +
            this.dados_formas_pagamento[c_cheque_prazo].valor +
            this.dados_formas_pagamento[c_cartao_debito].valor +
            this.dados_formas_pagamento[c_cartao_credito].valor +
            this.dados_formas_pagamento[c_duplicata].valor +
            this.dados_formas_pagamento[c_boleto].valor +
            this.dados_formas_pagamento[c_financeira].valor + 
            this.dados_formas_pagamento[c_acumulativo].valor +
            this.dados_formas_pagamento[c_pix].valor +
            this.dados_formas_pagamento[c_credito].valor
          ).toFixed(2);

          if (this.dados_formas_pagamento[c_total].valor > 0) {
            this.dados_formas_pagamento[c_dinheiro].percentual = (
              (
                this.dados_formas_pagamento[c_dinheiro].valor / 
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_cheque_vista].percentual = (
              (
                this.dados_formas_pagamento[c_cheque_vista].valor / 
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_cheque_prazo].percentual = (
              (
                this.dados_formas_pagamento[c_cheque_prazo].valor / 
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_cartao_debito].percentual = (
              (
                this.dados_formas_pagamento[c_cartao_debito].valor / 
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_cartao_credito].percentual = (
              (
                this.dados_formas_pagamento[c_cartao_credito].valor /
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_duplicata].percentual = (
              (
                this.dados_formas_pagamento[c_duplicata].valor /
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_boleto].percentual = (
              (
                this.dados_formas_pagamento[c_boleto].valor /
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_financeira].percentual = (
              (
                this.dados_formas_pagamento[c_financeira].valor /
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_acumulativo].percentual = (
              (
                this.dados_formas_pagamento[c_acumulativo].valor /
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_credito].percentual = (
              (
                this.dados_formas_pagamento[c_credito].valor /
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_pix].percentual = (
              (
                this.dados_formas_pagamento[c_pix].valor /
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);

            this.dados_formas_pagamento[c_total].percentual = (
              (
                this.dados_formas_pagamento[c_total].valor /
                this.dados_formas_pagamento[c_total].valor
              ) * 100
            ).toFixed(2);
          }
        }
        catch (error) {
          this.processando = false;
          toastr.error(error.message);
        }
      },

      getClasseGraficoHoras(percentual) {
        if (percentual > 100) {
          percentual = 100;
        }

        let retorno = 'c100 p' + Math.round(percentual) + ' big theme center';
        return retorno;
      },

      getPercentualMeta(percentual) {
        if (percentual > 999)
          percentual = '+' + 999;
          
        return percentual;
      },

      mostrarModalEmpresas() {
        this.mostrarModalInserirEmpresas = true
      },

      async buscarEmpresasAutorizadas() {
        try {
          if (!RSessao.carregouSessao()) {
            await RSessao.buscarDadosCarregarSessao(this.axios);
          }
          let empresas_disponivel = await JSON.parse(JSON.stringify(store.state.empresas_autorizadas));

          for (let i = 0; i < empresas_disponivel.length; i++) {
            if(empresas_disponivel[i].visualizar_dados == "S"){
              this.empresas_autorizadas.push(empresas_disponivel[i])
            }
          }
          for (let i = 0; i < this.empresas_autorizadas.length; i++) {
            this.empresas_autorizadas[i].adicionado = false;
            this.adicionarRemoverEmpresa(this.empresas_autorizadas[i].empresa_id, false);
          }
        }
        catch (error) {
          toastr.error('Erro ao buscar empresas autorizadas!');
        }
      },

      async buscarInformacoesPainelVendas() {
        try {
          this.dados_vendas_empresas = [];

          let empresas_ids = [];
          for (let i = 0; i < this.empresas_selecionadas.length; i++) {
            empresas_ids.push(this.empresas_selecionadas[i].empresa_id);
          }


          this.totais_todas_empresas.quantidade = 0;
          this.totais_todas_empresas.vendas = 0;
          this.totais_todas_empresas.devolucoes = 0;
          this.totais_todas_empresas.vendas_liquidas = 0;
          this.totais_todas_empresas.vendas_presente = 0;
          this.totais_todas_empresas.perc_lucro = 0;
          this.totais_todas_empresas.valor_lucro = 0;
          this.totais_todas_empresas.perc_lucro_presente = 0;
          this.totais_todas_empresas.valor_lucro_presente = 0;
          this.totais_todas_empresas.custos = 0;

          let parametros = {
            empresas_ids: empresas_ids,
            tipo_visao: this.tipo_visao,
            data: this.ano_base + '/' + this.mes_base,
            tipo_relatorio: this.tipo_processamento
          }

          let retorno = await RControleGerencial.buscarDadosPainelVendasControleGerencial(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          let dados = retorno.dados;

          for (let i = 0; i < dados.vendas.length; i++) {
            let linha = -1

            for (let j = 0; j < this.dados_vendas_empresas.length; j++) {
              if (this.dados_vendas_empresas[j].empresa_id == dados.vendas[i].empresa_id) {
                linha = j;
                break;
              }
            }

            this.totais_todas_empresas.quantidade += Biblioteca.valor(dados.vendas[i].quantidade);
            this.totais_todas_empresas.vendas += Biblioteca.valor(dados.vendas[i].vendas);
            this.totais_todas_empresas.custos += Biblioteca.valor(dados.vendas[i].custos);
            this.totais_todas_empresas.devolucoes += Biblioteca.valor(dados.vendas[i].devolucoes);
            this.totais_todas_empresas.vendas_liquidas += Biblioteca.valor(dados.vendas[i].vendas_liquidas);
            this.totais_todas_empresas.vendas_presente += Biblioteca.valor(dados.vendas[i].vendas_presente);
            this.totais_todas_empresas.valor_lucro += Biblioteca.valor(dados.vendas[i].valor_lucro);
            this.totais_todas_empresas.valor_lucro_presente += Biblioteca.valor(dados.vendas[i].valor_lucro_presente);

            if (linha == -1) {
              let nova_empresa = {
                empresa_id: dados.vendas[i].empresa_id,
                vendas: Biblioteca.valor(dados.vendas[i].vendas),
                custos: Biblioteca.valor(dados.vendas[i].custos),
                devolucoes: Biblioteca.valor(dados.vendas[i].devolucoes),
                vendas_liquidas: Biblioteca.valor(dados.vendas[i].vendas_liquidas),
                vendas_presente: Biblioteca.valor(dados.vendas[i].vendas_presente),
                quantidade: Biblioteca.valor(dados.vendas[i].quantidade),
                valor_lucro: Biblioteca.valor(dados.vendas[i].valor_lucro),
                perc_lucro: Biblioteca.valor(dados.vendas[i].perc_lucro),
                valor_lucro_presente: Biblioteca.valor(dados.vendas[i].valor_lucro_presente),
                perc_lucro_presente: Biblioteca.valor(dados.vendas[i].perc_lucro_presente),
                visualizar: false,
                detalhes: [
                  {
                    data_recebimento: dados.vendas[i].data_recebimento,
                    dia_semana: this.arrayDiasSemana[getObjData(dados.vendas[i].data_recebimento).getDay()],
                    vendas: dados.vendas[i].vendas,
                    custos: dados.vendas[i].custos,
                    devolucoes: dados.vendas[i].devolucoes,
                    vendas_liquidas: dados.vendas[i].vendas_liquidas,
                    vendas_presente: dados.vendas[i].vendas_presente,
                    quantidade: dados.vendas[i].quantidade,
                    valor_lucro: dados.vendas[i].valor_lucro,
                    perc_lucro: dados.vendas[i].perc_lucro,
                    valor_lucro_presente: dados.vendas[i].valor_lucro_presente,
                    perc_lucro_presente: dados.vendas[i].perc_lucro_presente,
                    visualizar: false
                  }
                ]
              };

              for (let k = 0; k < this.empresas_autorizadas.length; k++) {
                if (this.empresas_autorizadas[k].empresa_id == dados.vendas[i].empresa_id) {
                  nova_empresa.nome_fantasia = this.empresas_autorizadas[k].nome_fantasia;
                  break;
                }
              }

              this.dados_vendas_empresas.push(nova_empresa);
            }
            else {
              this.dados_vendas_empresas[linha].quantidade += Biblioteca.valor(dados.vendas[i].quantidade);
              this.dados_vendas_empresas[linha].vendas += Biblioteca.valor(dados.vendas[i].vendas);
              this.dados_vendas_empresas[linha].custos += Biblioteca.valor(dados.vendas[i].custos);
              this.dados_vendas_empresas[linha].devolucoes += Biblioteca.valor(dados.vendas[i].devolucoes);
              this.dados_vendas_empresas[linha].vendas_liquidas += Biblioteca.valor(dados.vendas[i].vendas_liquidas);
              this.dados_vendas_empresas[linha].vendas_presente += Biblioteca.valor(dados.vendas[i].vendas_presente);
              this.dados_vendas_empresas[linha].valor_lucro += Biblioteca.valor(dados.vendas[i].valor_lucro);
              this.dados_vendas_empresas[linha].valor_lucro_presente += Biblioteca.valor(dados.vendas[i].valor_lucro_presente);

              this.dados_vendas_empresas[linha].perc_lucro = CalcularPercValorLucroDbl(
                dados.tipo_analise_lucro,
                this.dados_vendas_empresas[linha].vendas_liquidas,
                this.dados_vendas_empresas[linha].custos,
                0,
                0
              );

              this.dados_vendas_empresas[linha].perc_lucro_presente = CalcularPercValorLucroDbl(
                dados.tipo_analise_lucro,
                this.dados_vendas_empresas[linha].vendas_presente,
                this.dados_vendas_empresas[linha].custos,
                0,
                0
              );

              let novo_detalhe = {
                data_recebimento: dados.vendas[i].data_recebimento,
                dia_semana: this.arrayDiasSemana[getObjData(dados.vendas[i].data_recebimento).getDay()],
                vendas: dados.vendas[i].vendas,
                custos: dados.vendas[i].custos,
                devolucoes: dados.vendas[i].devolucoes,
                vendas_liquidas: dados.vendas[i].vendas_liquidas,
                quantidade: dados.vendas[i].quantidade,
                valor_lucro: dados.vendas[i].valor_lucro,
                perc_lucro: dados.vendas[i].perc_lucro,
                valor_lucro_presente: dados.vendas[i].valor_lucro_presente,
                perc_lucro_presente: dados.vendas[i].perc_lucro_presente,
                vendas_presente: dados.vendas[i].vendas_presente,
                visualizar: false
              };

              this.dados_vendas_empresas[linha].detalhes.push(novo_detalhe);
            }
          }

          if (this.totais_todas_empresas.vendas_liquidas != 0) {
            this.totais_todas_empresas.perc_lucro = CalcularPercValorLucroDbl(
              dados.tipo_analise_lucro, 
              this.totais_todas_empresas.vendas_liquidas,
              this.totais_todas_empresas.custos,
              0,
              0
            );
          }

          if (this.totais_todas_empresas.vendas_presente != 0) {
            this.totais_todas_empresas.perc_lucro_presente = CalcularPercValorLucroDbl(
              dados.tipo_analise_lucro, 
              this.totais_todas_empresas.vendas_presente,
              this.totais_todas_empresas.custos,
              0,
              0
            );
          }
        } 
        catch (error) {
          toastr.error(error.message);
        }
      },

      mostrarDetalhesVendasEmpresas(empresa_id) {
        for (let i = 0; i < this.dados_vendas_empresas.length; i++) {        
          if (this.dados_vendas_empresas[i].empresa_id == empresa_id) {
            this.dados_vendas_empresas[i].visualizar = !this.dados_vendas_empresas[i].visualizar;
          }
          else {
            this.dados_vendas_empresas[i].visualizar = false;
          }
        }
      },

      mostrarDetalhesDetalheVendaEmpresa(empresa_id, data_recebimento) {
        for (let i = 0; i < this.dados_vendas_empresas.length; i++) {
          for (let j = 0; j < this.dados_vendas_empresas[i].detalhes.length; j++) {
            if (
              (this.dados_vendas_empresas[i].detalhes[j].data_recebimento == data_recebimento) && 
              (this.dados_vendas_empresas[i].empresa_id == empresa_id)
            ) {
              this.dados_vendas_empresas[i].detalhes[j].visualizar = !this.dados_vendas_empresas[i].detalhes[j].visualizar;
            }
            else {
              this.dados_vendas_empresas[i].detalhes[j].visualizar = false;
            }
          }
        }
      },

      getMesBaseFormatado() {
        return (getMesAnalitico(this.mes_base));
      },

      adicionarRemoverEmpresa(empresa_id, adicionado) {
        if (adicionado) {
          for (let i = 0; i < this.empresas_autorizadas.length; i++) {
            if (this.empresas_autorizadas[i].empresa_id == empresa_id) {
              this.empresas_autorizadas[i].adicionado = false;
              break;
            }
          }
    
          for (let i = 0; i < this.empresas_selecionadas.length; i++) {
            if (this.empresas_selecionadas[i].empresa_id == empresa_id) {
              this.empresas_selecionadas.splice(i, 1);
              break;
            }
          }
        }
        else {
          for (let i = 0; i < this.empresas_autorizadas.length; i++) {
            if (this.empresas_autorizadas[i].empresa_id == empresa_id) {
              this.empresas_autorizadas[i].adicionado = true;
              this.empresas_selecionadas.push(this.empresas_autorizadas[i]);
              break;
            }
          }
        }
      },

      getClasseEmpresaDisponivel(adicionado) {
        if (adicionado) {
          return 'w3-theme label-clicavel';
        }
        else {
          return 'w3-white label-clicavel';
        }
      },

      formatarValor(valor, quant_casas_decimais = 2) {
        return formatarValorGeral(valor, quant_casas_decimais);
      }
    },

    async created() {
      let data_atual = new Date();
      data_atual = data_atual.toLocaleString();

      if (Biblioteca.valorInt(data_atual.slice(3, 5)) < 10) {
        this.mes_base = data_atual.slice(4, 5);
      }
      else {
        this.mes_base = data_atual.slice(3, 5);
      }

      this.ano_base = data_atual.slice(6, 10);

      this.arrayDiasSemana = new Array(7);
      this.arrayDiasSemana[0] = 'Domingo';
      this.arrayDiasSemana[1] = 'Segunda';
      this.arrayDiasSemana[2] = 'Terça';
      this.arrayDiasSemana[3] = 'Quarta';
      this.arrayDiasSemana[4] = 'Quinta';
      this.arrayDiasSemana[5] = 'Sexta';
      this.arrayDiasSemana[6] = 'Sábado';

      this.processado_hoje = false;
      this.processado_mes_ano = false;

      await this.buscarEmpresasAutorizadas();
      this.tipo_visao = await localStorage.getItem('tipo_visao_controle_gerencial');
    }
  }

  function ExibirGraficoVendas(
    data_recebimento,
    data_recebimento_mes_anterior,
    data_recebimento_ano_anterior,
    valor_venda_ano_anterior,
    valor_venda_mes_anterior, valor_venda
  ) {
    $('#painel_vendas').remove(); 
    $('#vendasChart').append('<canvas id="painel_vendas"><canvas>');

    var ctxVendas = document.getElementById('painel_vendas').getContext('2d');
    var array_data_recebimento = [];
    var array_valor_venda_ano_anterior = [];
    var array_valor_venda_mes_anterior = [];
    var array_valor_venda = [];

    var dias_graficos = [];

    for (var i = 1; i <= 31; i++) {
      dias_graficos.push(i);
    }

    for (var i = 0; i < dias_graficos.length; i++) {
      var index = -1;
      for (var j = 0; j < data_recebimento.length; j++) {
        if (data_recebimento[j].data.slice(0, 2) == dias_graficos[i]) {
          index = j;
          break;
        }
      }

      if (index > -1) {
        array_data_recebimento.push(data_recebimento[index].data.slice(0, 2))
        array_valor_venda.push(valor_venda[index].valor_mes_base);
      }
      else {
        if (dias_graficos[i] < 10) {
          array_data_recebimento.push('0' + String(dias_graficos[i]));
        }
        else {
          array_data_recebimento.push(dias_graficos[i]);
        }

        array_valor_venda.push(0);
      }
      
      index = -1;
      for (var j = 0; j < data_recebimento_mes_anterior.length; j++) {
        if (data_recebimento_mes_anterior[j].data_mes_anterior.slice(0, 2) == dias_graficos[i]) {
          index = j;
          break;
        }
      }

      if (index > -1) {
        array_valor_venda_mes_anterior.push(valor_venda_mes_anterior[index].valor_mes_anterior);
      }
      else {
        array_valor_venda_mes_anterior.push(0);
      }
      
      index = -1;
      for (var j = 0; j < data_recebimento_ano_anterior.length; j++) {
        if (data_recebimento_ano_anterior[j].data_ano_anterior.slice(0, 2) == dias_graficos[i]) {
          index = j;
          break;
        }
      }

      if (index > -1) {
        valor_venda_ano_anterior[index].valor_ano_anterior = valor_venda_ano_anterior[index].valor_ano_anterior.replace(".",'');
        valor_venda_ano_anterior[index].valor_ano_anterior = valor_venda_ano_anterior[index].valor_ano_anterior.replace(",",'');
        array_valor_venda_ano_anterior.push(valor_venda_ano_anterior[index].valor_ano_anterior);
      }
      else {
        array_valor_venda_ano_anterior.push(0);
      }
    }

    var chartVendas = new Chart(
      ctxVendas, 
      {
        type: 'line',

        data: {
          labels: array_data_recebimento,

          datasets: [
            {
              label: 'Valores ano anterior ',
              borderColor: 'Orange',
              backgroundColor: "transparent",
              data: array_valor_venda_ano_anterior,
              type: 'line',
            },

            {
              label: 'Valores mês anterior' ,
              borderColor: 'fuchsia',
              backgroundColor: "transparent",
              data: array_valor_venda_mes_anterior,
              type: 'line',
            },

            {
              label: 'Valores mês da pesquisa',
              borderColor: 'Blue',
              backgroundColor: "transparent",
              data: array_valor_venda,
              type: 'line',
            }
          ]
        },

        options: {
        
          legend: {display: true},
          title: {
            fontSize: 18
          },

          showAllTooltips: true, // call plugin we created
          responsive: true,
          cutoutPercentage: 60,

          animation: {
            animateScale: true,
            animateRotate: true
          },

          scales: {
            xAxes: [{
              ticks: {
                fontSize: 16
              }
            }],

            yAxes: [{
              ticks: {
                fontSize: 16
              }
            }]
          },

          tooltips: {
            enabled: true,
            bodyFontSize: 16,

            callbacks: {
              title: function(tooltipItems, data) {
                return "";
              },

              label: function(tooltipItem, data) {
                var datasetLabel = "";
                var label_tooltip =  data.datasets[tooltipItem.datasetIndex].label;
                return nPadrao(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], 2)?
                label_tooltip+":  " + "R$ "+ nPadrao(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], 2) :
                "sem informações";
              }
            }
          }
        }
      }
    );
  }

  function ExibirGraficoTicket(
    data_recebimento,
    data_recebimento_mes_anterior,
    data_recebimento_ano_anterior,
    valor_ticket_ano_anterior,
    valor_ticket_mes_anterior,
    ticket_medio
  ) {
    $('#painel_ticket').remove(); 
    $('#ticketChart').append('<canvas id="painel_ticket"><canvas>');
    
    var ctxTicket = document.getElementById('painel_ticket').getContext('2d');
    var array_data_recebimento = [];
    var array_valor_ticket_ano_anterior = [];
    var array_valor_ticket_mes_anterior = [];
    var array_ticket_medio = [];
    var i = "";

    var dias_graficos = [];
    
    for (var i = 1; i <= 31; i++) {
      dias_graficos.push(i);
    }

    for (var i = 0; i < dias_graficos.length; i++) {
      var index = -1;
      for (var j = 0; j < data_recebimento.length; j++) {
        if (data_recebimento[j].data.slice(0, 2) == dias_graficos[i]){
          index = j;
          break;
        }
      }
    
      if (index > -1) {
        array_data_recebimento.push(data_recebimento[index].data.slice(0, 2))
        array_ticket_medio.push(ticket_medio[index].ticket_mes_base);
      }
      else {
        if (dias_graficos[i] < 10) {
          array_data_recebimento.push('0' + String(dias_graficos[i]));
        }
        else {
          array_data_recebimento.push(dias_graficos[i]);
        }

        array_ticket_medio.push(0);
      }

      index = -1;

      for (var j = 0; j < data_recebimento_mes_anterior.length; j++) {
        if (data_recebimento_mes_anterior[j].data_mes_anterior.slice(0, 2) == dias_graficos[i]) {
          index = j;
          break;
        }
      }
    
      if (index > -1) {
        array_valor_ticket_mes_anterior.push(valor_ticket_mes_anterior[index].ticket_mes_anterior);
      }
      else {
        array_valor_ticket_mes_anterior.push(0);
      }

      index = -1;
      for (var j = 0; j < data_recebimento_ano_anterior.length; j++) {
        if (data_recebimento_ano_anterior[j].data_ano_anterior.slice(0, 2) == dias_graficos[i]) {
          index = j;
          break;
        }
      }
    
      if (index > -1) {
        valor_ticket_ano_anterior[index].ticket_ano_anterior = valor_ticket_ano_anterior[index].ticket_ano_anterior.replace(".","");
        valor_ticket_ano_anterior[index].ticket_ano_anterior = valor_ticket_ano_anterior[index].ticket_ano_anterior.replace(",","");
        array_valor_ticket_ano_anterior.push(valor_ticket_ano_anterior[index].ticket_ano_anterior);
      }
      else {
        array_valor_ticket_ano_anterior.push(0);
      }
    }

    var chartTicket = new Chart(
      ctxTicket, 
      {
        type: 'line',

        data: {
          labels: array_data_recebimento,

          datasets: [
            {
              label: 'Valores ano anterior',
              borderColor: 'Orange',
              backgroundColor: "transparent",
              data: array_valor_ticket_ano_anterior,
              type: 'line'
            },

            {
              label: 'Valores mês anterior',
              borderColor: 'fuchsia',
              backgroundColor: "transparent",
              data: array_valor_ticket_mes_anterior,
              type: 'line'
            },

            {
              label: 'Valor mês da pesquisa',
              borderColor: 'Blue',
              backgroundColor: "transparent",
              data: array_ticket_medio,
              type: 'line'
            }
          ]
        },
        options: {
          responsive: true,
          legend: {display: true},
          
          title: {
            fontSize: 18
          },

          showAllTooltips: true,
          responsive: true,
          cutoutPercentage: 60,

          animation: {
            animateScale: true,
            animateRotate: true
          },

          scales: {
            xAxes: [{
              ticks: {
                fontSize: 16
              }
            }],
            yAxes: [
              {
                ticks: {
                  fontSize: 16
                }
              }
            ]
          },

          tooltips: {
            enabled: true,
            bodyFontSize: 16,
            callbacks: {
              title: function(tooltipItems, data) {
                return "";
              },

              label: function(tooltipItem, data) {
                var datasetLabel = "";
                var label_tooltip =  data.datasets[tooltipItem.datasetIndex].label;
                return nPadrao(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], 2)?
                label_tooltip+":  " + "R$ "+ nPadrao(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], 2) :
                "sem informações";
              }
            }
          }
        }
      }
    );
  }

  function ExibirGraficoLucros(
    data_recebimento,
    data_recebimento_mes_anterior,
    data_recebimento_ano_anterior,
    valor_lucro_ano_anterior,
    valor_lucro_mes_anterior,
    lucro_percentual
  ) {
    $('#painel_lucro').remove(); 
    $('#lucroChart').append('<canvas id="painel_lucro"><canvas>');

    var ctxLucro = document.getElementById('painel_lucro').getContext('2d');
    var array_data_recebimento = [];
    var array_valor_lucro_ano_anterior = [];
    var array_valor_lucro_mes_anterior = [];
    var array_lucro_percentual = [];
    var i = "";

    var dias_graficos = [];

    for (var i = 1; i <= 31; i++) {
      dias_graficos.push(i);
    }

    for (var i = 0; i < dias_graficos.length; i++) {
      var index = -1;
      
      for (var j = 0; j < data_recebimento.length; j++) {
        if (data_recebimento[j].data.slice(0, 2) == dias_graficos[i]) {
          index = j;
          break;
        }
      }
    
      if (index > -1) {
        array_data_recebimento.push(data_recebimento[index].data.slice(0, 2));
        array_lucro_percentual.push(lucro_percentual[index].lucro_mes_base);
      }
      else {
        if (dias_graficos[i] < 10) {
          array_data_recebimento.push('0' + String(dias_graficos[i]));
        }
        else {
          array_data_recebimento.push(dias_graficos[i]);
        }        

        array_lucro_percentual.push(0);
      }

      index = -1;

      for (var j = 0; j < data_recebimento_mes_anterior.length; j++) {
        if (data_recebimento_mes_anterior[j].data_mes_anterior.slice(0, 2) == dias_graficos[i]) {
          index = j;
          break;
        }
      }
    
      if (index > -1) {
        array_valor_lucro_mes_anterior.push(valor_lucro_mes_anterior[index].lucro_mes_anterior);
      }
      else {
        array_valor_lucro_mes_anterior.push(0);
      }
      
      index = -1;
      for (var j = 0; j < data_recebimento_ano_anterior.length; j++) {
        if (data_recebimento_ano_anterior[j].data_ano_anterior.slice(0, 2) == dias_graficos[i]) {
          index = j;
          break;
        }
      }
    
      if (index > -1) {
        valor_lucro_ano_anterior[index].lucro_ano_anterior = valor_lucro_ano_anterior[index].lucro_ano_anterior.replace(".","");
        valor_lucro_ano_anterior[index].lucro_ano_anterior = valor_lucro_ano_anterior[index].lucro_ano_anterior.replace(",","");
        array_valor_lucro_ano_anterior.push(valor_lucro_ano_anterior[index].lucro_ano_anterior);
      }
      else {
        array_valor_lucro_ano_anterior.push(0);
      }
    }

    var chartLucro = new Chart(
      ctxLucro, 
      {
        type: 'line',
        data: {

          labels: array_data_recebimento,

          datasets: [
            {
              label: 'Valores ano anterior',
              borderColor: 'Orange',
              backgroundColor: 'transparent',
              data: array_valor_lucro_ano_anterior,
              type: 'line'
            },

            {
              label: 'Valores mês anterior',
              borderColor: 'fuchsia',
              backgroundColor: 'transparent',
              data: array_valor_lucro_mes_anterior,
              type: 'line'
            },

            {
              label: 'Valor mês da pesquisa',
              data: array_lucro_percentual,
              borderColor: 'Blue',
              backgroundColor: 'transparent',
              type: 'line'
            }
          ]
        },

        options: {
          responsive: true,
          legend: {display: true},
          title: {
            fontSize: 18
          },
          showAllTooltips: true, // call plugin we created
          responsive: true,
          cutoutPercentage: 60,
          animation: {
            animateScale: true,
            animateRotate: true
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontSize: 16
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  fontSize: 16
                }
              }
            ]
          },

          tooltips: {
            enabled: true,
            bodyFontSize: 16,
            callbacks: {
              title: function(tooltipItems, data) {
                return "";
              },

              label: function(tooltipItem, data) {
                var datasetLabel = "";
                var label_tooltip =  data.datasets[tooltipItem.datasetIndex].label;
                return nPadrao(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], 2)?
                label_tooltip+":  " + "R$ "+ nPadrao(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], 2) :
                "sem informações";
              }
            }
          }
        }
      }
    );
  }
</script>

<style scoped>
  .filtro-controlegerencial {
    margin-top: 20px;
    float: left; 
    width: 100%;
  }

  .filtro-controlegerencial > div:not(:last-of-type) {
    border: 1px solid #9c1d1c;
    padding: 5px !important;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c;
  }

  .filtro-controlegerencial h5 {
    color: #9c1d1c;
    font-weight: bold;
  }

  .filtro-controlegerencial > div.margin-aplicada {
    margin-right: 20px !important;
  }
  
  .filtro-controlegerencial > div:last-of-type {
    margin-top: 10px;
  }

  @media screen and (min-width: 1180px) {
    .filtro-controlegerencial > div.tres {
      width: calc((100% - 40px) / 3) !important;
      margin-bottom: 20px;
    }
  }

  @media screen and (max-width: 1179px) {
    .filtro-controlegerencial > div.tres {
      width: calc((100% - 40px) /2) !important;
      margin-bottom: 20px;
    }

    .filtro-controlegerencial > div.tres:nth-child(3) {
      float: right !important;
      margin-right: 0 !important;
    }

    .filtro-controlegerencial > div.opcoes-mes,
    .filtro-controlegerencial > div.opcoes-exibicao {
      width: 100% !important;
    }

    .filtro-controlegerencial > div:last-of-type {
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 767px) {
    header h5, header button {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    h2 {
      font-size: 24px;
      margin-bottom:15px;
    }

    #formulario_filtro{
      padding: 0px !important;
    }

    .filtro-controlegerencial h5 {
      text-align: center !important;
    }

    .filtro-controlegerencial > div.tres {
      width: 100%  !important;
    }

    .filtro-controlegerencial > div.margin-aplicada {
      margin-right: 0px !important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ControleGerencial.vue